export interface PastMedicalHistoryCondition {
  key: string;
  label: string;
  value: boolean;
  description?: string;
}

// Medical history conditions for display
export const MEDICAL_HISTORY_CONDITIONS = [
  { key: "diabetes", label: "Diabetes" },
  { key: "hypertension", label: "Hypertension" },
  { key: "heartDisease", label: "Heart Disease" },
  { key: "highCholesterol", label: "High Cholesterol" },
  { key: "asthma", label: "Asthma" },
  { key: "thyroidDisorder", label: "Thyroid Disorder" },
  { key: "autoimmuneDisease", label: "Autoimmune Disease" },
  { key: "ibsIbd", label: "IBS/IBD" },
  { key: "gerd", label: "GERD" },
  { key: "migraines", label: "Migraines" },
  { key: "anxietyDepression", label: "Anxiety/Depression" },
  { key: "chronicFatigue", label: "Chronic Fatigue" },
  { key: "cancer", label: "Cancer" },
  { key: "neurologicalConditions", label: "Neurological Conditions" },
] as const;

export type MedicalHistoryConditionKey =
  (typeof MEDICAL_HISTORY_CONDITIONS)[number]["key"];

// Text fields for medical history (short fields)
export const MEDICAL_HISTORY_SHORT_FIELDS = [
  { key: "cancerType", label: "Cancer Type" },
  { key: "other", label: "Other Conditions" },
  { key: "surgeriesHospitalizations", label: "Surgeries/Hospitalizations" },
  { key: "significantInjuries", label: "Significant Injuries" },
  { key: "allergies", label: "Allergies" },
] as const;

// Long text fields (textarea)
export const MEDICAL_HISTORY_LONG_FIELDS = [
  { key: "additionalNotes", label: "Additional Notes" },
] as const;

export type MedicalHistoryShortFieldKey =
  (typeof MEDICAL_HISTORY_SHORT_FIELDS)[number]["key"];
export type MedicalHistoryLongFieldKey =
  (typeof MEDICAL_HISTORY_LONG_FIELDS)[number]["key"];
